// extracted by mini-css-extract-plugin
export default {"main":"App_main__B5p1U"};